import { action } from '@ember/object';
import type Owner from '@ember/owner';
import { htmlSafe } from '@ember/template';
import type { SafeString } from '@ember/template';
import Component from '@glimmer/component';

import { ApiMetricBuilderWizardStep } from 'webapp/enums/enums';

import FormCodeEditorComponent from 'webapp/components/form/code-editor';
import ToolTipWithIconComponent from 'webapp/components/tool-tip-with-icon';

import type CustomMetricSetupFormApiMetricBuilder from 'webapp/models-custom/custom-metric-setup-form/api-metric-builder';

interface Args {
	form: CustomMetricSetupFormApiMetricBuilder;
	isDisabled: boolean;
	theme: string;
	maxHeight: number | null;
	onContentChange: () => void;
}

export default class CustomQuerySetupApiMetricBuilderExtractionExpressionComponent extends Component<Args> {
	constructor(owner: Owner, args: Args) {
		super(owner, args);

		this.preselectRowsIfNoneSelected();
		this.args.form.updateExtractionExpression();
	}

	get editorWrapperStyle(): SafeString {
		const styleString = this.args.maxHeight ? `height:${this.args.maxHeight}px` : '';
		return htmlSafe(styleString);
	}

	@action
	onTextChange(text: string): void {
		this.args.form.extractionExpression = text;
	}

	private preselectRowsIfNoneSelected(): void {
		const jsonStructure = this.args.form.jsonStructure;
		if (!jsonStructure) {
			return;
		}

		if (!jsonStructure.rowMetric) {
			const step = ApiMetricBuilderWizardStep.METRIC;
			const row = jsonStructure.getFirstAvailableRow(step) || null;
			jsonStructure.setRowForWizardStep(step, row);
		}

		// always allow "None": discussed in https://app.asana.com/0/0/1203600470514962/1204062844384812/f
		// if (!jsonStructure.rowDimension && !jsonStructure.rowDate) {
		// 	// not valid if one of these is not selected

		// 	let step = ApiMetricBuilderWizardStep.DATE;
		// 	let row = jsonStructure.getFirstAvailableRow(step) || null;
		// 	jsonStructure.setRowForWizardStep(step, row);

		// 	step = ApiMetricBuilderWizardStep.DIMENSION;
		// 	row = jsonStructure.getFirstAvailableRow(step) || null;
		// 	jsonStructure.setRowForWizardStep(step, row);
		// }
	}
	<template>
		<div class="row">
			<strong>
				Customize JSONata expression
				<ToolTipWithIconComponent
					@text="More info about JSONata <a href='https://jsonata.org/' target='_blank'>here</a>"
					@maxWidth={{250}}
				/>
			</strong>

			<div class="editor-wrapper" style={{this.editorWrapperStyle}}>
				<FormCodeEditorComponent
					@text={{@form.extractionExpression}}
					@mode="text"
					@isReadOnly={{@isDisabled}}
					@onTextChange={{this.onTextChange}}
					@theme={{@theme}}
					@height={{@maxHeight}}
				/>
			</div>

		</div>
	</template>
}
